import { Button } from "@arcadeai/design-system/components/ui/atoms/button";
import { Input } from "@arcadeai/design-system/components/ui/atoms/input";
import { Skeleton } from "@arcadeai/design-system/components/ui/atoms/skeleton";
import { ChevronDown, Filter, Search, Settings2, Wrench } from "lucide-react";
import { ListLayout } from "@/components/custom/list-layout/list-layout";

const ToolkitCardSkeleton = () => (
  <div className="overflow-hidden rounded-xl border bg-card dark:border-white/5">
    <div className="flex w-full items-center gap-3 px-3 py-3 sm:py-4">
      {/* Toolkit Icon */}
      <div className="flex size-10 shrink-0 items-center justify-center rounded-lg bg-gradient-to-b from-neutral-200 to-neutral-100 shadow-sm ring-1 ring-black/5 dark:from-neutral-800 dark:to-neutral-900 dark:ring-white/5">
        <Skeleton className="size-5" />
      </div>

      {/* Toolkit Name & Description */}
      <div className="flex min-w-0 flex-1 flex-col gap-1">
        <div className="flex items-center gap-3">
          <Skeleton className="h-5 w-32 sm:h-6" />
          <Skeleton className="hidden h-4 w-12 sm:inline" />
        </div>
        <Skeleton className="h-4 w-full max-w-md" />
      </div>

      {/* Right side badges and chevron */}
      <div className="flex shrink-0 items-center gap-1.5">
        <Skeleton className="h-8 w-20 rounded-md" />
        <span className="inline-flex h-8 shrink-0 items-center gap-1.5 rounded-md border border-transparent bg-muted/80 px-2.5 font-medium text-muted-foreground text-sm">
          <Wrench className="size-3" />
          <Skeleton className="h-4 w-12" />
        </span>
        <div className="flex size-7 shrink-0 items-center justify-center">
          <ChevronDown className="size-5 text-muted-foreground" />
        </div>
      </div>
    </div>
  </div>
);

const FiltersBarSkeleton = () => (
  <div className="flex flex-wrap items-center gap-2">
    {/* Search input */}
    <div className="relative min-w-[200px] flex-1">
      <Search className="pointer-events-none absolute top-1/2 left-3 size-4 -translate-y-1/2 text-muted-foreground" />
      <Input className="h-8 pl-9 text-sm" disabled placeholder="Search..." />
    </div>

    {/* View options button */}
    <Button className="h-9 gap-2 px-3" disabled size="sm" variant="outline">
      <Settings2 className="size-4" />
      Columns
    </Button>

    {/* Filter buttons */}
    <Button className="h-8 border-dashed" disabled size="sm" variant="outline">
      <Filter className="mr-2 size-4" />
      Auth Providers
    </Button>
    <Button className="h-8 border-dashed" disabled size="sm" variant="outline">
      <Filter className="mr-2 size-4" />
      Secrets
    </Button>
    <Button className="h-8 border-dashed" disabled size="sm" variant="outline">
      <Filter className="mr-2 size-4" />
      MCP Servers
    </Button>
  </div>
);

export const ToolsListSkeleton = () => (
  <ListLayout
    description="List of tools that are available to use."
    filters={<FiltersBarSkeleton />}
    title="Tools"
  >
    <div className="flex flex-col gap-4">
      {Array.from({ length: 20 }, (_, i) => (
        // biome-ignore lint/suspicious/noArrayIndexKey: Static skeleton items never reorder
        <ToolkitCardSkeleton key={i} />
      ))}
    </div>
  </ListLayout>
);
